import { useCallback, useEffect, useRef } from "react";

function useDebounceCallback(delay: number) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debounceCallback = useCallback(
    (callback: () => void) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        callback();
      }, delay);
    },
    [delay],
  );

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return debounceCallback;
}

export default useDebounceCallback;
